import React from "react";

import { Locale, SupportedLocales } from "./enhancedIntlModel";

export type EnhancedIntl = {
  defaultLocale: Locale;
  supportedLocales: SupportedLocales;
  locale: Locale;
  setLocale: React.Dispatch<React.SetStateAction<Locale>>;
};

export const EnhancedIntlContext = React.createContext<
  EnhancedIntl | undefined
>(undefined);

export default EnhancedIntlContext;
